import { IMAGE_NUMBER_TYPE } from "@visactor/vrender-core";

export class DefaultMathImagePicker {
    constructor() {
        this.type = "image", this.numberType = IMAGE_NUMBER_TYPE;
    }
    contains(image, point, params) {
        const {pickContext: pickContext} = null != params ? params : {};
        return !!pickContext && !!image.AABBBounds.containsPoint(point);
    }
}
//# sourceMappingURL=image-picker.js.map
